import axios from 'axios';
// import axiosRetry from 'axios-retry';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import toastr from 'toastr';
import labsServices from './laboratories.services';
// const client = axios.create({ baseURL: process.env.REACT_APP_URL });
// axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const resetVaccines = () => async (dispatch, getState) => {
  dispatch({
    type: actions.FORM_FAIL,
    payload: "",
  });
}

export const getLabs = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_LABS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.get(data.itype === 1 ? `/api/app/Formal_Laboratorio/` : `/api/app/Funcional_Laboratorio/`, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await labsServices.getLabs(data, data.itype);
    dispatch({
      type: actions.GET_LABS,
      payload: {
        labs: resp.data.data,
        labsLength: resp.data.count
      }
    });
    dispatch({
      type: actions.LABS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if(ex.response.data && ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      }else{
        message = messages.networkError;
      }
    }else{
      message = messages.applicationError
    }
    dispatch({
      type: actions.LABS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_LABS,
      payload: false
    });
  }
}

export const saveLabs = (data, itype, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LABS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(itype === 1 ? `/api/app/Formal_Laboratorio/` : `/api/app/Funcional_Laboratorio/`, data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await labsServices.saveLabs(data, itype);
    const { labs, labsLength } = getState().labs;
    const aLabs = [...labs, resp.data];
    dispatch({
      type: actions.GET_LABS,
      payload: {
        labs: aLabs,
        labsLength: labsLength + 1
      }
    });
    setShowModal(false)
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_LABS,
      payload: false
    });
  }
}

export const editLabs = (data, id, index, itype, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_LABS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(itype === 1 ? `/api/app/Formal_Laboratorio/${id}/` : `/api/app/Funcional_Laboratorio/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await labsServices.editLabs(id, data, itype);
    const { labs, labsLength } = getState().labs;
    labs[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_LABS,
      payload: {
        labs: labs,
        labsLength: labsLength
      }
    });
    setShowModal(false)
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if(ex.response.data.mensaje){
              message = ex.response.data.mensaje;
            }else{
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.SAVE_LOADING_LABS,
      payload: false
    });
  }
}

export const deleteLabs = (id, index, itype) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_LABS,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(itype === 1 ? `/api/app/Formal_Laboratorio/${id}/` : `/api/app/Funcional_Laboratorio/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await labsServices.deleteLabs(id, itype);
    const { labs, labsLength } = getState().labs;
    labs.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_LABS,
      payload: {
        labs: labs,
        labsLength: labsLength -1
      }
    });
    dispatch({
      type: actions.LABS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.LABS_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_LABS,
      payload: false
    });
  }
}